<template>
  <div class="ui-toolbar">
      <div :class="{ 'wrapper': size == '1200', 'wrappers': size == '1400'} ">
        <router-link class="logo" tag='div' :to="info.merchantCode ? { path: `/${info.merchantCode}` } : ''">
          <img src="data:image/png;base64,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">
        </router-link>
        <h4 class="title">积分商城</h4>
        <div class="login-box">
          <div class="login-list">
            <i class="icons login-icon"></i>
              {{u.customName || ''}}
            <i class="icons icons-ups"></i>
          </div>
          <div class="login-out ar" @click="onOut">
            <span>退出登录</span>
          </div>
        </div>
      </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "TopLogo",
  computed: {
    ...mapGetters({ info: "shopInfo",u:"user" })
  },
  props: {
    size: {
      type: String,
      default: "1200"
    }
  },
  methods: {
    onOut() {
      localStorage.removeItem("token");
      localStorage.removeItem("userinfo");
      localStorage.removeItem("shopinfo");
      window.location.href = this.$conf.Api.url + "/my-account";
    }
  }
};
</script>
<style scoped>
.login-box {
  position: absolute;
  right: 0;
  top: 0;
  padding: 0 10px 0 10px;
  border: 1px solid rgba(255, 255, 255, 0);
  border-top: none;
  font-size: 12px;
  cursor: pointer;
  z-index: 22;
}
.login-icon {
  background-position: -28px -160px;
  display: inline-block;
  width: 20px;
  height: 20px;
  cursor: pointer;
  vertical-align: -5px;
  margin-right: 3px;
}
.icons-ups {
  background-position: -20px -183px;
  display: inline-block;
  width: 15px;
  height: 9px;
  cursor: pointer;
  vertical-align: -1px;
  margin-right: 3px;
}
.login-list {
  height: 59px;
  line-height: 60px;
}
.login-box:hover {
  background-color: #f8f8f8;
  border-color: #e5e5e5;
  -webkit-box-shadow: 0 0 3px rgba(0, 0, 0, 0.0470588);
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.0470588);
}
.login-box:hover .login-out {
  display: block;
}
.login-out {
  display: none;
  padding-right: 16px;
  margin-bottom: 10px;
  line-height: 36px;
}
.login-out:hover {
  background-color: #eee;
}
.ui-toolbar {
  height: 60px;
  background-color: #fff;
  z-index: 10;
  -moz-box-shadow: 1px 1px 10px #eee;
  -webkit-box-shadow: 1px 1px 10px #eee;
  box-shadow: 1px 1px 10px #eee;
}
.ui-toolbar .wrapper {
  width: 1200px;
  height: 60px;
  margin: auto;
  text-align: left;
  position: relative;
}
.ui-toolbar .wrappers {
  width: 1400px;
  height: 60px;
  margin: auto;
  text-align: left;
  position: relative;
}
.logo {
  background-color: #ed6c00;
  width: 100px;
  height: 100%;
  float: left;
}
.ui-toolbar .title {
  font-size: 18px;
  color: #333;
  margin: 18px;
  display: inline-block;
  font-weight: inherit;
}
</style>
